<div class="layout-col full">
  <span style="width: 30vw"></span>

  <app-material-detail class="flex" [material]="material" (close)="onClose($event)">
  </app-material-detail>
</div>
